import React, { useCallback, useEffect, useRef, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Parser from 'html-react-parser';
import Typography from '@material-ui/core/Typography/Typography';
import {useTranslation} from 'react-i18next';
import MaterialTable from 'material-table';
import Platform from 'react-platform-js'
import LogoGc from '../../assets/logo.gc.png'
import LogoSw from '../../assets/logo.scrw.png'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0.5, 0.5),
    boxShadow: `3px 3px 5px ${theme.palette.base[200]}`,
    minHeight: "50vh",
  },
  versionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  versionContainerColumn: {
    display: 'flex',
    margin: '10px',
    marginRight: '100px',
    flexDirection: 'column',
    alignItems: 'left',
  },
  aboutContent:{
	  minHeight: "50vh",
	  padding: theme.spacing(1.5),
	  flexWrap: 'wrap',
  },
  row:{
	  marginTop: theme.spacing(1.5),
  },
  title: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
  },
}));

const cellStyle = {
  paddingLeft: 4,
  paddingRight: 4,
  lineHeight: '19px',
  color: '#1B1B28',
};


function AboutPaper(props) {

  const classes = useStyles();
  const {t} = useTranslation();

  const {
    user,
    aboutList,
    fetchAboutList,
    isFetchingAboutList,
  } = props;

  const [rowDetailName, setRowDetailName] = useState({});
  const isUnMounted = useRef(false);
  useEffect(() => {
    getVersion();
    isUnMounted.current = false;
    return () => {
      isUnMounted.current = true;
    };
  }, []);

  const [windowsVersion, setWindowsVersion] = useState('');

  const getVersion = () => {
    if ( !window.navigator.userAgent.includes('Firefox') && !window.navigator.userAgent.includes('Safari') ) {
      window.navigator.userAgentData.getHighEntropyValues(["platformVersion"])
        .then(ua => {
          if (navigator.userAgentData.platform === "Windows") {
            const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
            if (majorPlatformVersion >= 13) {
              setWindowsVersion('11');
            } else if (majorPlatformVersion > 0) {
              setWindowsVersion('10');
            }
            else {
              setWindowsVersion('Before 10');
            }
          }
      });
    } else {
      setWindowsVersion('10/11');
    }
  }


  const aboutListFce = useCallback(() => {
    if (
      user
      && user.subjectId
      && !isFetchingAboutList
    ) {
      fetchAboutList().then(() => {
        if (!isUnMounted.current) {
          //setIsFetchedAboutList(true);
          // setIsLoadingAboutList(false);
        }
      }).catch(() => {
        if (!isUnMounted.current) {
          //setIsFetchedAboutList(false);
          // setIsLoadingAboutList(false);
        }
      });
    }
  }, [fetchAboutList, isFetchingAboutList, user]);

  useEffect(() => {
    if (!isFetchingAboutList) {
      aboutListFce();
    }
  }, [aboutListFce, isFetchingAboutList, user]);

  const onRowClick = (event, rowId) => {
    if ( rowDetailName!=rowId.versionName) {
      setRowDetailName(rowId.versionName);
    } else {
      setRowDetailName('');
    }
  };

  const renderAbouts = (about) => {
    const rowsNotes = [];
    if (isFetchingAboutList && about || about.messages)  {
      about.messages.forEach((element) => {
        rowsNotes.push(
            <>{Parser(element.message)}</>
        );
      });
    }

    const columns = [
      {  
        title: t('VERSION_NAME'),
        field: 'versionName',
        headerStyle: {textAlign: 'left', paddingLeft: 5},
        cellStyle: {
            ...cellStyle,
            align: 'center',
        },
        render: (rowData) => (
          rowData.versionName
        )
      },
      {   
        title: 'Version change log',
        field: t('CHANGE_LOG'),
        headerStyle: {textAlign: 'left', paddingLeft: 5},
        cellStyle: {
            ...cellStyle,
            align: 'center',
        },
        render: (rowData) => (
          <>
            {rowData.versionName === rowDetailName &&
              Parser(rowData.changeLog)
            }
            {rowData.versionName !== rowDetailName &&
              t('CLICK_FOR_DETAIL')
            }
          </>
        )
      },
    ];

    return (
      <>
        <div className={classes.container}>
          <Paper className={classes.aboutContent}>
            {about.messages && about.messages && about.messages.length > 0 && 
              <>
                  <h2>{t('ABOUT_VERSION')}:{about.messages[0].message.split(',')[0].split(':')[1]}</h2> 
                  <div>{t('ABOUT_BUILD')}: {about.messages[0].message.split(',')[1].split(':')[1]}</div>
                  <div>{t('ABOUT_COMMIT')}: {about.messages[0].message.split(',')[2].split(':')[1]}</div>
              </>
            }



            <div>
              <Platform >
                {props => {
                  return (
                    <>
                      <h2>{t('ABOUT_VERSION_BROWSER')}: {props.Browser} {props.BrowserVersion}</h2>
                      <div>{t('ABOUT_VERSION_SYSTEM')}: {props.OS} {props.OS==='Windows' && windowsVersion!==''?windowsVersion:props.OSVersion}</div>
                    </>
                  )
                }}
              </Platform>
            </div>

            <div className={classes.versionContainer}>
              <div className={classes.versionContainerColumn}>  
                <h2>{t('ABOUT_SUPPORT')}</h2>
              </div>
              <div className={classes.versionContainerColumn} style={{paddingLeft: '50px'}}>  
                <h2>{t('ABOUT_COOPERATION')}</h2>
              </div>
            </div>
            <div className={classes.versionContainer}>
              <div className={classes.versionContainerColumn}><img maxHeight='20px' src={LogoGc} style={{paddingBottom: '20px'}}/> 
                <div>{t('ABOUT_PHONE')}: +420 266 312 201</div> 
                <div>{t('ABOUT_EMAIL')}: <a href='mailto:support@green.cz'>support@green.cz</a></div> 
              </div>
              <div className={classes.versionContainerColumn}><img maxHeight='40px' src={LogoSw} style={{paddingBottom: '20px'}}/> 
                <div>{t('ABOUT_PHONE')}: +420 731 647 333</div> 
                <div>{t('ABOUT_EMAIL')}: <a href='mailto:hello@scrumware.eu'>hello@scrumware.eu</a></div> 
              </div>
            </div>

          </Paper>
        </div>
        <Typography variant="h4" className={classes.title}>
          {t('RELEASE_NOTES')}
        </Typography>
        <div className={classes.container}>
          <Paper className={classes.aboutContent}>
            <MaterialTable
                localization={{
                    body: {
                        emptyDataSourceMessage: t('NO_RECORD'),
                    },
                    toolbar: {
                        exportName: 'Export',
                        searchTooltip: t('SEARCH_INNER'),
                        searchPlaceholder: t('SEARCH_INNER'),
                    }
                }}
                columns={columns}
                data={about.versions}
                onRowClick={onRowClick}
                options={{
                    search: false,
                    paging: false,
                    showTitle: false
                }}
                style={{
                    boxShadow: 'none',
                    padding: '0 10px',
                }}
            />          
          </Paper>
        </div>
      </>
    );
  };


  return (
    <>
      {renderAbouts(aboutList)}
    </>
  );
}


AboutPaper.propTypes = {
  user: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  aboutList: PropTypes.array.isRequired,
  fetchAboutList: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  user: store.authData.user,
  // isRO: store.authData.isRO,
  aboutList: store.aboutData.aboutList,
  isUpdating: store.aboutData.isUpdating,
});

export default connect(
  mapStateToProps,
)(AboutPaper);
